import { z } from 'zod';

import { makeEndpoint } from '../common';

export enum CurationSessionLocation {
  ON_PROPERTY = 'on-property',
  OFF_PROPERTY = 'off-property',
  BOTH = 'both',
}

export const BaseAiCurationSessionSchema = z.object({
  id: z.string().uuid().optional(),
  count: z.number().positive(),
  creativity: z.number().min(0).max(100),
  location: z.nativeEnum(CurationSessionLocation),
  prompt: z.string().nullable(),
});

export type BaseAiCurationSession = z.infer<typeof BaseAiCurationSessionSchema>;

export const AiCurationSessionSchema = BaseAiCurationSessionSchema.extend({
  id: z.string().uuid(),
  generatedExperienceCount: z.number(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type AiCurationSession = z.infer<typeof AiCurationSessionSchema>;

export const GetAiCurationSessionsEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ brandId }: { brandId: string }) => `v1/ai/brands/${brandId}/curation-sessions`,
  requestSchema: z.void(),
  responseSchema: z.array(AiCurationSessionSchema),
});

export const PostAiCurationSessionEndpoint = makeEndpoint({
  method: 'POST',
  url: ({ brandId }: { brandId: string }) => `v1/ai/brands/${brandId}/curation-sessions`,
  requestSchema: BaseAiCurationSessionSchema,
  responseSchema: AiCurationSessionSchema,
});

export const PutAiCurationSessionEndpoint = makeEndpoint({
  method: 'PUT',
  url: ({ brandId, curationSessionId }: { brandId: string; curationSessionId: string }) =>
    `v1/ai/brands/${brandId}/curation-sessions/${curationSessionId}`,
  requestSchema: BaseAiCurationSessionSchema.omit({ id: true }),
  responseSchema: AiCurationSessionSchema,
});

export const DeleteAiCurationSessionEndpoint = makeEndpoint({
  method: 'DELETE',
  url: ({ brandId, curationSessionId }: { brandId: string; curationSessionId: string }) =>
    `v1/ai/brands/${brandId}/curation-sessions/${curationSessionId}`,
  responseSchema: z.void(),
  requestSchema: z.void(),
});
